<template>
  <div style="margin-top: 0px; background-color: #fdffff">
    <div style=" text-align: center;"><img src="@/assets/mlogo.png"></div>
    <div style=" text-align: center; font-size: large;color: #9d7648">产品追溯平台查询结果</div>
    <br/>
    <div style="text-align: center; font-size: medium; color: #9d7648">
      <van-row>
        <van-col offset="3" span="18">身份码：{{ identity }}</van-col>
      </van-row>
      <van-row>
        <van-col offset="3" span="18">验证码：{{ no }}</van-col>
      </van-row>
      <van-row>
        <van-col offset="3" span="18">查询时间：{{ currtime }}</van-col>
      </van-row>
      <van-row v-if="success">
        <van-col offset="3" span="18">产品名称：{{ goods_name }}</van-col>
      </van-row>
      <van-row v-if="success">
        <van-col offset="3" span="18">生产日期：
          {{ produce_time ? produce_time.substring(0, 10) : '' }}
        </van-col>
      </van-row>
    </div>
    <div style="font-size: medium; margin: 20px; line-height: 30px; color: darkgreen;">
      <hr  width="85%" color="#ffaa22" size="2" />
      <div style="margin: 0 auto; width: 85%" v-if="success">
        <div style="text-align: center; font-size: xx-large"><van-icon name="passed" /></div>
      &nbsp; &nbsp; &nbsp; &nbsp;再次感谢您选购我公司产品！您当前查询的产品为我公司正品，此产品之前进行过 {{ count }} 次防伪查询。
        <span v-if="count!='0'">第一次查询时间为 {{ verifytime }}。</span>
      </div>
      <div style="margin: 0 auto; width: 85%;color: firebrick;" v-else>
        <div style="text-align: center; font-size: xx-large"><van-icon name="close" /></div>
        &nbsp; &nbsp; &nbsp; &nbsp;请注意：您验证的产品在我公司数据云中验证失败！
      </div>
      <hr  width="85%" color="#ffaa22" size="2" />
    </div>

<!--    <div v-if="success && details && details.length > 0"-->
<!--         style="font-size: 12px; margin: 20px; line-height: 18px; color: darkgray;">-->
<!--      <van-row>-->
<!--        <van-col :offset="2" :span="20">-->
<!--          原料：-->
<!--          <span v-for="(detail, index) in details" :key="detail.id">-->
<!--            <span v-if="index === details.length - 1">-->
<!--              {{ detail.name }}。-->
<!--            </span>-->
<!--            <span v-else>-->
<!--              {{ detail.name }}，-->
<!--            </span>-->
<!--          </span>-->
<!--        </van-col>-->
<!--      </van-row>-->
<!--      <hr width="85%" color="#ffaa22" size="2" />-->
<!--    </div>-->
    <div style="font-size: smaller; margin-left: 30px; line-height: 24px;color: #9d7648;"
         v-if="trace_page_footer.length > 0">
      <van-row>
        <van-col offset="3" span="18">出品商：{{ trace_page_footer[0] }}</van-col>
      </van-row>
      <van-row>
        <van-col offset="3" span="18">联系电话：{{ trace_page_footer[1] }}</van-col>
      </van-row>
      <van-row>
        <van-col offset="3" span="18">生产商：{{ trace_page_footer[2] }}</van-col>
      </van-row>
      <van-row>
        <van-col offset="3" span="18">食品生产许可证编号：{{ trace_page_footer[3] }}</van-col>
      </van-row>
      <van-row>
        <van-col offset="3" span="18">企业官网：<a :href="trace_page_footer[4]">{{ trace_page_footer[4] }}</a></van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import { verifyCode } from '@/api/commons'
export default {
  name: 'VerifyCode',
  data: function () {
    return {
      id: "",
      no: "",
      success: false,
      count: "1",
      currtime: this.Utils.df(null, '{y}-{m}-{d} {h}:{i}:{s}'),
      verifytime: this.Utils.df(null, '{y}-{m}-{d} {h}:{i}:{s}'),
      details: [],
      identity: '',
      goods_name: '',
      produce_time: '',
      trace_page_footer: []
    }
  },
  //启动后默认执行
  mounted: function () {
    this.id = this.$route.query.id
    this.no = this.$route.query.no
    if (this.id && this.no) {
      this.verification()
    } else {
      this.error("信息错误！")
    }
  },
  methods: {
    verification: function () {
      const loading = this.$toast.loading({mask: true, duration: 0, message: '验证中...'});
      verifyCode({
        id: parseInt(this.id),
        code: this.no
      }).then(resp => {
        this.success = resp.success
        if (this.success) {
          this.success = parseInt(resp.obj.id) === parseInt(this.id)
          this.count = resp.obj.verify_count
          this.verifytime = resp.obj.verify_time
          this.goods_name = resp.obj.goods_name
          this.details = resp.obj.details
          this.identity = resp.obj.identity
          this.produce_time = resp.obj.produce_time
          if (resp.obj.trace_page_footer) {
            this.trace_page_footer = resp.obj.trace_page_footer.split('|')
          }
        } else {
          this.toast(resp.msg)
        }
        loading.clear()
      }).catch(function (error) {
        loading.clear()
        console.error(error)
      })
    }
  }
}
</script>
<style type="text/css">
  a:link {
    color: #9d7648;
    text-decoration: none;
  }
  a:visited {
    color: #9d7648;
    text-decoration: none;
  }
  a:hover {
    color: #9d7648;
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/components/verify-code.vue